"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSendNavigationSignal = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../../../constants");
var _context = require("../../../context");
var _navigation = require("../../../context/navigation");
var _utils = require("../../../utils");
/* istanbul ignore file -- api call */

const useSendNavigationSignal = ({
  query,
  type
}) => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    results,
    timestamp
  } = (0, _navigation.useSearchInput)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    sessionId
  } = (0, _context.useAppConfig)();
  const sendNavigationSignal = (0, _react.useCallback)(async (position, code) => {
    if (!results) {
      return;
    }
    const analyticsData = _utils.analytics.getSignalsData({
      customerId,
      position,
      results,
      timestamp,
      query,
      sessionId,
      code,
      type
    });
    await (0, _globalApiClientReact.createApplicationsNavigationSignal)(globalApiClient, analyticsData, {
      [_constants.ACCEPT_LANGUAGE]: language,
      [_fetching.TENANT_CONTEXT]: tenant
    });
  }, [results, customerId, timestamp, query, sessionId, type, globalApiClient, language, tenant]);
  return {
    sendNavigationSignal
  };
};
exports.useSendNavigationSignal = useSendNavigationSignal;
//# sourceMappingURL=useSendNavigationSignal.js.map